// extracted by mini-css-extract-plugin
module.exports = {"fwd_select_block":"SelectBlock_fwd_select_block__OcZSH","fwd_select_option":"SelectBlock_fwd_select_option__Kr735"};